"use client";

import { ActionIcon, Tooltip, useMantineColorScheme, Box } from "@mantine/core";
import { Sun, Moon } from "lucide-react";

export function ThemeSwitch() {
    const { colorScheme, setColorScheme } = useMantineColorScheme();

    const toggleColorScheme = () => {
        setColorScheme(colorScheme === 'dark' ? 'light' : 'dark');
    };

    return (
        <Tooltip label={colorScheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
            <ActionIcon
                variant="subtle"
                color="gray"
                onClick={toggleColorScheme}
                size="lg"
                aria-label="Toggle color scheme"
            >
                <Box component={Sun} size={20} strokeWidth={1.5} className="theme-icon-sun" />
                <Box component={Moon} size={20} strokeWidth={1.5} className="theme-icon-moon" />
            </ActionIcon>
        </Tooltip>
    );
}
